// Appointment color scheme based on service types
// This utility provides consistent color coding across the application

export const getAppointmentColors = (service) => {
  const serviceColors = {
    'Tree Planting': {
      primary: '#10b981', // Emerald green
      secondary: '#d1fae5', // Light emerald
      accent: '#059669', // Dark emerald
      borderColor: '#059669', // Color for border highlight
      description: 'Professional tree planting service'
    },
    'Tree Trimming': {
      primary: '#3b82f6', // Blue
      secondary: '#dbeafe', // Light blue
      accent: '#1d4ed8', // Dark blue
      borderColor: '#1d4ed8', // Color for border highlight
      description: 'Expert pruning and trimming'
    },
    'Tree Removal': {
      primary: '#ef4444', // Red
      secondary: '#fee2e2', // Light red
      accent: '#dc2626', // Dark red
      borderColor: '#dc2626', // Color for border highlight
      description: 'Safe tree removal service'
    },
    'Stump Grinding': {
      primary: '#8b5cf6', // Purple
      secondary: '#ede9fe', // Light purple
      accent: '#7c3aed', // Dark purple
      borderColor: '#7c3aed', // Color for border highlight
      description: 'Professional stump removal'
    },
    'Land Clearing': {
      primary: '#f59e0b', // Amber
      secondary: '#fef3c7', // Light amber
      accent: '#d97706', // Dark amber
      borderColor: '#d97706', // Color for border highlight
      description: 'Complete land clearing service'
    },
    'Emergency Services': {
      primary: '#f97316', // Orange
      secondary: '#fed7aa', // Light orange
      accent: '#ea580c', // Dark orange
      borderColor: '#ea580c', // Color for border highlight
      description: 'Emergency tree service'
    }
  };

  return serviceColors[service] || {
    primary: '#6b7280', // Gray fallback
    secondary: '#f3f4f6',
    accent: '#4b5563',
    borderColor: '#4b5563', // Color for border highlight
    description: 'Tree service'
  };
};

// Function to get status colors based on appointment status
export const getStatusColors = (status, serviceColors) => {
  const statusColorMap = {
    'confirmed': {
      backgroundColor: serviceColors.secondary,
      color: serviceColors.accent,
      border: `${serviceColors.primary}40`
    },
    'pending': {
      backgroundColor: '#fef3c7',
      color: '#d97706',
      border: '#f59e0b40'
    },
    'completed': {
      backgroundColor: serviceColors.secondary,
      color: serviceColors.accent,
      border: `${serviceColors.primary}40`
    },
    'cancelled': {
      backgroundColor: '#fee2e2',
      color: '#dc2626',
      border: '#ef444440'
    },
    'rejected': {
      backgroundColor: '#fee2e2',
      color: '#dc2626',
      border: '#ef444440'
    }
  };

  return statusColorMap[status] || {
    backgroundColor: '#f3f4f6',
    color: '#6b7280',
    border: '#6b728040'
  };
};

// Function to get service icon with color styling
export const getServiceIcon = (service, size = '48px') => {
  const colors = getAppointmentColors(service);
  return {
    icon: colors.icon,
    style: {
      backgroundColor: colors.primary,
      color: 'white',
      borderRadius: '50%',
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: size === '48px' ? '20px' : '16px',
      fontWeight: 'bold',
      boxShadow: `0 4px 12px ${colors.primary}40`
    }
  };
};

// Function to get all available service types
export const getServiceTypes = () => {
  return [
    'Tree Planting',
    'Tree Trimming', 
    'Tree Removal',
    'Stump Grinding',
    'Land Clearing',
    'Emergency Services'
  ];
};

// Function to get color palette for a specific service
export const getServicePalette = (service) => {
  const colors = getAppointmentColors(service);
  return {
    primary: colors.primary,
    secondary: colors.secondary,
    accent: colors.accent,
    light: colors.secondary,
    dark: colors.accent,
    icon: colors.icon
  };
};
